import {ListFeaturesItemProps} from '../../../components/ListFeatures/components/ListFeaturesItem';
import {i18n} from '../../../i18n/i18n';

/**
 * Every Carvago vehicle passes the same checks; nothing is read from the audit. Ordered so the two
 * columns read as in the design: the first four checks fill the left one.
 */
export const getHistoryChecks = (): ListFeaturesItemProps[] =>
  [
    i18n.t('historyCheck.vehicleHistory'),
    i18n.t('historyCheck.mileage'),
    i18n.t('historyCheck.damage'),
    i18n.t('historyCheck.serviceRecords'),
    i18n.t('historyCheck.theft'),
    i18n.t('historyCheck.activeFinancing'),
    i18n.t('historyCheck.taxiUse'),
    i18n.t('historyCheck.equipment'),
  ].map((title) => ({title, variant: 'ready'}));
